"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertDateFormatToUnicode = void 0;
var date_formatter_token_1 = require("../../../../types/functions/date-formatter-token");
var unicode_date_formatter_token_1 = require("../../../../types/functions/unicode-date-formatter-token");
var format_date_1 = require("../format-date");
// Create a map from old tokens to their modern unicode equivalent
var unicodeTokenMap = Object.entries(date_formatter_token_1.DateFormatterToken).reduce(function (acc, _a) {
    var _b;
    var name = _a[0], value = _a[1];
    return __assign(__assign({}, acc), (_b = {}, _b[value.toString()] = unicode_date_formatter_token_1.UnicodeDateFormatterToken[name], _b));
}, {});
/**
 * Converts a legacy date format to unicode format that is compatible with date-fns v2
 * @param formatString The legacy date format string to convert
 */
function convertDateFormatToUnicode(formatString) {
    var matches = formatString.match(format_date_1.formattingTokensRegex);
    var tokens = matches.filter(Boolean).map(function (match) { return unicodeTokenMap[match] || match; });
    return tokens.join('');
}
exports.convertDateFormatToUnicode = convertDateFormatToUnicode;
//# sourceMappingURL=convert-date-format-to-unicode.js.map